import React from 'react'
import classnames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import { cdnImg } from 'meinian-package/src/utils/image'
import { LazyLoadImage } from 'meinian-package/src/baseComponent'
import './index.less'

export default (props) => {
  const { itemData, mainUrl, onClickCard, selectedData, columnWidth, hiddenClose, onDeleteItem } = props
  return <div className="mn-upgrade-common-card" style={{ width: columnWidth, height: props.width ? Math.round((columnWidth * props.height) / props.width) : columnWidth }}>
    {
        hiddenClose ? null : <div
          className="mn-upgrade-common-card-close-icon"
          onClick={(e) => {
            e.stopPropagation()
            onDeleteItem()
          }}
        ><Icon type="m-jianshao" /></div>
      }
    <LazyLoadImage
      src={cdnImg(mainUrl, 200)}
      className={classnames('image-item', { active: selectedData.some(k => k.mainUrl === mainUrl) })}
      onClick={e => (onClickCard?.(itemData, e))}
    />
  </div>
}

export const Image = ({ src, width, height, style, children, onClick, className }) => {
  return <div
    className={classnames('meinian-imagebox-thumb', className, { 'can-click': !!onClick })}
    onClick={onClick}
    style={{ backgroundImage: `url(${src})`, width, height, ...style }}
  >
    {children}
  </div>
}
